import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(private http: HttpClient) { }

  saveFeedback(payload): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.FEEDBACK, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getFeedbackById(id) {
    return this.http.get<any>(urls.BASE_URL + urls.FEEDBACK + `/${id}`)
      .pipe(
        catchError(errorHandl)
      );
  }

  updateFeedback(payload): Observable<any> {
    return this.http.put<any>(urls.BASE_URL + urls.FEEDBACK + `/${payload.assign}`, payload)
      .pipe(
        catchError(errorHandl)
      );
  }
}
